import psl from 'psl'

const DONATION_REMINDER_COOKIE = 'donationReminder'

export const applePayIsSupported = () => {
  return window.ApplePaySession && window.ApplePaySession.supportsVersion(3) && window.ApplePaySession.canMakePayments()
}

/**
 * Push the checkout event to the data layer
 * @param {{}} gaDataLayer
 *   The GA data layer.
 * @param {string} stepId
 *   The step ID.
 * @param {string} stepOption
 *   The step option.
 * @param {number} giftaidRate
 *   The Gift Aid rate.
 * @param {{
 *   order_id        : string,
 *   payment_amount  : string,
 *   payment_method  : string,
 *   payment_provider: string,
 *   payment_type    : string,
 *   product_title   : string,
 * }} currentValues
 */
export const dataLayerPushCheckoutEvent = (gaDataLayer, stepId, stepOption, currentValues, giftaidRate) => {
  const dataLayerData = dataLayerCheckoutStepEventBuild(stepId, stepOption, currentValues, giftaidRate)
  console.log('dataLayerData', dataLayerData)
  dataLayerData.eventTimeout  = 2500
  gaDataLayer.push(dataLayerData)
}

/**
 * Push the error to the dataLayer.
 *
 * @param {{}} gaDataLayer
 *   The GA data layer.
 * @param {{}} error
 *   The error object.
 */
export const dataLayerPushError = (gaDataLayer, error) => {
  const event = {
    event                  : 'donationFailed',
    message                : error.message,
    processorResponseCode  : error.processorResponseCode ? error.processorResponseCode : '',
    processorResponseText  : error.processorResponseText ? error.processorResponseText : '',
    processorResponseType  : error.processorResponseType ? error.processorResponseType : '',
    processorResponseStatus: error.processorResponseStatus ? error.processorResponseStatus : '',
  }

  gaDataLayer.push(event)
}


/**
 * Build out the transaction event.
 *
 * @param {{}} gaDataLayer
 *   The GA data layer.
 * @param {{
 *   order_id        : string,
 *   payment_amount  : string,
 *   payment_method  : string,
 *   payment_provider: string,
 *   payment_type    : string,
 *   product_title   : string,
 * }} currentValues
 * @param {number} giftaidRate
 *   The giftaid rate to use.
 * @param {number} donationFeeRate
 *   The donation fee rate to use.
 * @param {Function} nextAction
 *   The function call once the dataLayer push has completed
 */
export const dataLayerPushTransaction = (gaDataLayer, currentValues, giftaidRate, donationFeeRate,  nextAction) => {
  const dataLayerData = dataLayerTransactionEventBuild(currentValues, giftaidRate, donationFeeRate)
  console.log('dataLayerData', dataLayerData)
  console.log('dataLayerData', JSON.stringify(dataLayerData))

  dataLayerData.eventCallback = () => {
    // nextAction()
    // document.location = thankYouPage + (thankYouPage.includes('?') ? '&' : '?') + Object.keys(currentValues)
    //   .filter(key => validParams.includes(key)).map(key => { return `${key}=${currentValues[key]}` }).join('&')
  }
  dataLayerData.eventTimeout  = 2500

  console.log('DATA LAYER PUSH', dataLayerData)

  gaDataLayer.push(dataLayerData)

  // Data layer Push at of consent values
  if (currentValues.optin_email === 'Y' || currentValues.optin_telephone === 'Y') {
    const optInValues = {
      event: 'form_consent',
      form_name: formDetails.formTitle,
      "gtm.elementId": formDetails.formID,
    }
    if (currentValues.optin_email === 'Y') {
      optInValues.email_consent = "yes";
    }
    if (currentValues.optin_telephone === 'Y') {
      optInValues.phone_consent = "yes";
    }
    gaDataLayer.push(optInValues);
    console.log('DATA LAYER PUSH - OPTIN', optInValues)
  }
}

/**
 * Build out the transaction event.
 *
 * @param {string} stepId
 *   The step ID.
 * @param {string} stepOption
 *   The step option.
 * @param {{
 *   order_id        : string,
 *   payment_amount  : string,
 *   payment_method  : string,
 *   payment_provider: string,
 *   payment_type    : string,
 *   product_title   : string,
 * }} currentValues
 * @param {number} giftaidRate
 *   The Gift Aid rate.
 * @returns {{
 *   ecommerce: {
 *     purchase: {
 *       actionField: {
 *         affiliation: string,
 *         coupon     : number,
 *         id         : string,
 *         revenue    : string,
 *         shipping   : number,
 *         tax        : number,
 *       },
 *       products: [
 *         {
 *           category: string,
 *           name    : string,
 *           price   : string,
 *           quantity: number,
 *           variant : string,
 *         }
 *       ]
 *     },
 *     currencyCode: string
 *   },
 *   event: string
 * }}
 */
const dataLayerCheckoutStepEventBuild = (stepId, stepOption, currentValues, giftaidRate) => {
  const data =  {
    'event': 'checkout',
    'ecommerce': {
      'currencyCode': 'GBP',
      'checkout': {
        'actionField': {
          'step'  : stepId,
          'option': stepOption
        },
        'products': [{
          'name'    : currentValues.product_title ? currentValues.product_title : currentValues.payment_type === 'recurring' ? 'Month' : 'Once',
          'price'   : Number(currentValues.payment_amount).toFixed(2),
          'category': currentValues.payment_type === 'recurring' ? 'Month' : 'Once',
          'variant' : currentValues.payment_provider === 'RSM' ? 'Direct Debit' : currentValues.payment_provider === 'Paypal' ? 'Paypal' : currentValues.payment_method,
          'quantity': 1
        }]
      }
    }
  }

  if (currentValues['giftaid'] === 'Y') {
    data.ecommerce.checkout.products.push({
      'name'    : 'Gift Aid',
      'price'   : ((Number(currentValues.payment_amount) * giftaidRate) - Number(currentValues.payment_amount)).toFixed(2),
      'category': 'Gift Aid',
      'variant' : currentValues.payment_provider === 'RSM' ? 'Direct Debit' : currentValues.payment_provider === 'Paypal' ? 'Paypal' : currentValues.payment_method,
      'quantity': 1
    })
  }

  return data
}


/**
 * Build out the transaction event.
 *
 * @param {{
 *   order_id        : string,
 *   payment_amount  : string,
 *   payment_method  : string,
 *   payment_provider: string,
 *   payment_type    : string,
 *   product_title   : string,
 * }} currentValues
 * @param {number} giftaidRate
 *   The giftaid rate to use.
 * @param {number} donationFeeRate
 *   The donation fee rate to use.
 * @returns {{
 *   ecommerce: {
 *     purchase: {
 *       actionField: {
 *         affiliation: string,
 *         coupon     : number,
 *         id         : string,
 *         revenue    : string,
 *         shipping   : number,
 *         tax        : number,
 *       },
 *       products: [
 *         {
 *           category: string,
 *           name    : string,
 *           price   : string,
 *           quantity: number,
 *           variant : string,
 *         }
 *       ]
 *     },
 *     currencyCode: string
 *   },
 *   event: string
 * }}
 */
export const dataLayerTransactionEventBuild = (currentValues, giftaidRate, donationFeeRate) => {
  const isRecurring = currentValues.payment_type === 'recurring'|| currentValues.payment_type === 'monthly';
  const paymentMethod = currentValues.payment_provider === 'RSM' ? 'Direct Debit' : currentValues.payment_provider === 'Paypal' ? 'Paypal' : currentValues.payment_method;
  const amount = ((currentValues.cover_donation_fee === 'Y' && donationFeeRate)
    ? (parseFloat(currentValues.payment_amount) * donationFeeRate)
    : Number(currentValues.payment_amount))
      .toFixed(2);

  const data = {
    'event': 'transaction',
    'ecommerce': {
      'currencyCode': 'GBP',
      'purchase': {
        'actionField': {
          'id'         : currentValues.order_id,
          'affiliation': isRecurring,
          'revenue'    : amount,
          'tax'        : 0,
          'shipping'   : 0,
          'coupon'     : 0
        },

        'products': [{
          'name'    : currentValues.product_title ? currentValues.product_title : (isRecurring ? 'Monthly' : 'Once'),
          'price'   : amount,
          'category': isRecurring ? 'Month' : 'Once',
          'variant' : currentValues.payment_provider === 'RSM' ? 'Direct Debit' : currentValues.payment_provider === 'Paypal' ? 'Paypal' : currentValues.payment_method,
          'quantity': 1
        }]
      }
    }
  }

  // If it's a multi-buy.
  if (Array.isArray(currentValues.order_items) && currentValues.order_items.length) {
    // Update products array with multi buy options.
    data.ecommerce.purchase.products = dataLayerBuildProducts(currentValues, isRecurring, paymentMethod);
  }

  if (currentValues['giftaid'] === 'Y') {
    data.ecommerce.purchase.products.push({
      'name'    : 'Gift Aid',
      'price'   : ((Number(currentValues.payment_amount) * giftaidRate) - Number(currentValues.payment_amount)).toFixed(2),
      'category': 'Gift Aid',
      'variant' : currentValues.payment_provider === 'RSM' ? 'Direct Debit' : currentValues.payment_provider === 'Paypal' ? 'Paypal' : currentValues.payment_method,
      'quantity': 1
    })
  }

  return data
}


/**
 * Build out the transaction event.
 *
 * @param {{
*   order_id        : string,
*   payment_amount  : string,
*   payment_method  : string,
*   payment_provider: string,
*   payment_type    : string,
*   product_title   : string,
* }} currentValues
* @param {boolean} isRecurring
*   If the payment is one-off or recurring
* @param {string} paymentProvider
*   The payment provider service
*
* @returns {{
*   products: [
*     {
*       category: string,
*       name    : string,
*       price   : string,
*       quantity: number,
*       variant : string,
*     }
*   ]
* }}
*/
const dataLayerBuildProducts = (currentValues, isRecurring, paymentProvider) => {
  const products = [];

  currentValues.order_items.forEach(product => {
    const name = '' + product.product_id.replace('_', ' ') + ' pen sponsorship' + (product.is_gift ? ' gift' : '');
    const productKey = product.product_id + product.amount.toString() + (product.is_gift ? '_gift' : '');

    if (productKey in products ) {
      products[productKey].quantity += 1;
    } else {
      products[productKey] = {
        'name'    : name.charAt(0).toUpperCase() + name.slice(1), // name to sentence case upper case.
        'price'   : Number(product.amount).toFixed(2),
        'category': isRecurring ? 'Month' : 'Once',
        'variant' : paymentProvider,
        'quantity': 1
      }
    }
  });

  // Abstract products array for dataLayer.
  const abstract = []
  for (const [key, value] of Object.entries(products)) {
    abstract.push(value);
  }

  return abstract;
}

/**
 * Check the visibility for the given element.
 *
 * @param {{ conditions: {hidden: {}, visible: {}, visually_hidden: {}, gift_only: boolean}}} element
 *   The element to check.
 * @param {{}} currentValues
 *   The current values to check against.
 *
 * @returns {boolean}
 *   A boolean indicating if element should be visible.
 */
export const elementCheckVisibility = (element, currentValues, isGift = false) => {
  if (element.conditions) {
    if (element.conditions.visible) {
      return Object.keys(element.conditions.visible).reduce((visible, valueKey) => {
        return currentValues[valueKey] && element.conditions.visible[valueKey].values.includes(currentValues[valueKey]) ? true : visible
      }, false)
    }
    else if (element.conditions.hidden) {
      return Object.keys(element.conditions.hidden).reduce((visible, valueKey) => {
        if (currentValues[valueKey]) {
          if (element.conditions.hidden[valueKey].not_empty) {
            return false
          }
          else if(element.conditions.hidden[valueKey].values) {
            return !element.conditions.hidden[valueKey].values.includes(currentValues[valueKey])
          }
        }

        return visible
      }, true)
    }
    else if (element.conditions.visually_hidden) {
      return Object.keys(element.conditions.visually_hidden).reduce((visible, valueKey) => {
        if (currentValues[valueKey]) {
          if (element.conditions.visually_hidden[valueKey].not_empty) {
            return false
          }
          else if(element.conditions.visually_hidden[valueKey].values) {
            return !element.conditions.visually_hidden[valueKey].values.includes(currentValues[valueKey])
          }
        }
        else if (element.conditions.hidden[valueKey].empty) {
          return false
        }

        return visible
      }, true)
    }
    else if (typeof element.conditions.gift_only != 'undefined') {
      if (element.conditions.gift_only) {
        return isGift
      }
      else {
        return  !isGift
      }
    }
  }

  return true
}

/**
 * Check the visibility for the given element.
 *
 * @param {{ conditions: {hidden: {}, visible: {}, visually_hidden: {}}}} element
 *   The element to check.
 * @param {{}} currentValues
 *   The current values to check against.
 *
 * @returns {boolean}
 *   A boolean indicating if element should be visible.
 */
export const elementCheckVisuallyHidden = (element, currentValues) => {
  if (element.conditions) {
    if (element.conditions.visually_hidden) {
      return Object.keys(element.conditions.visually_hidden).reduce((visible, valueKey) => {
        if (currentValues[valueKey]) {
          if (element.conditions.visually_hidden[valueKey].not_empty) {
            return false
          }
          else if(element.conditions.visually_hidden[valueKey].values) {
            return !element.conditions.visually_hidden[valueKey].values.includes(currentValues[valueKey])
          }
        }
        else if (element.conditions.visually_hidden[valueKey].empty) {
          return true
        }

        return visible
      }, false)
    }
  }

  return false
}

export const getCookie = cname => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const sessionStateGet = () => {
  const sessionData = localStorage.getItem('sponsorshipData')
  const timeInSeconds = Date.now() / 1000
  if (sessionData) {
    try {
      const sessionValues = JSON.parse(sessionData)

      if ((timeInSeconds - sessionValues.created) < 3600) {
        return  sessionValues
      }
    } catch (e) {
      console.error(e.message)
      return values
    }
  }

  return {}
}


/**
 * Build out the transaction event.
 *
 * @param userValues
 *   An instance of the stateManager.userValues
 * @param {boolean} invalidate if true delete this cookie
 */
export const setDonationReminderCookie = (userValues, invalidate = false) => {
  // Cookie domain
  const parsedDomain = psl.parse(window.location.hostname);
  if (!invalidate) {
    let currentDonationValue = 0;
    if (userValues.order_items && userValues.order_items.length > 0) {
      userValues.order_items.forEach(item => {
        currentDonationValue += item.amount
      });
    } else {
      currentDonationValue = userValues.payment_amount
    }

    if (!isNaN(currentDonationValue) && !isNaN(parseFloat(currentDonationValue)) && parseFloat(currentDonationValue) > 0 ) {

      const cookieValue = encodeURIComponent(JSON.stringify({
        a: currentDonationValue, // Amount
        p: window.location.href, // Last visited page
        t: (userValues.payment_method === 'Direct debit' && userValues.payment_type === 'monthly')
        ? 'sponsorship'
        : (userValues.payment_type == 'recurring' ? 'monthly' : userValues.payment_type), // Type (monthly, sponsorship or single)
      }));

      // Cookie expiry
      const expires = new Date();
      expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
      document.cookie = `${DONATION_REMINDER_COOKIE}=${cookieValue};domain=${parsedDomain.domain};expires=${expires.toUTCString()};path=/;secure=true`;
    } else {
      document.cookie = `${DONATION_REMINDER_COOKIE}=;domain=${parsedDomain.domain};expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;secure=true`;
    }
  } else {
    document.cookie = `${DONATION_REMINDER_COOKIE}=;domain=${parsedDomain.domain};expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;secure=true`;
  }
}


/**
 *
 * @param {string} status the status code or status flag of the API response
 * @param {string} reason the concrete reason of the error
 */
export const dataLayerPushDonationFailed = (status, reason) => {
  window.dataLayer = window.dataLayer || []

  const error = {
    event: 'donation_failed',
    form_name: formDetails ? formDetails.formTitle : window.location.href,
    response: status,
    reason: reason,
  }

  console.log('Hit dataLayer push!', error)

  // Custom Donation failed event.
  window.dataLayer.push(error)
}

/**
 * Validate Email address with Loqate service
 *
 * @param {string} email email to validate
 * @param {string} key Loqate API key
 */
export const loqateValidateEmail = (email, key, callback) => {
  let url = 'https://api.addressy.com/EmailValidation/Interactive/Validate/v2.00/json3.ws';
  let params = '';
  params += "&Key=" + encodeURIComponent(key);
  params += "&Email=" + encodeURIComponent(email);
  const http = new XMLHttpRequest();
  http.open('POST', url, true);
  http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  http.onreadystatechange = function() {
    if(http.readyState == 4 && http.status == 200) {
      const response = JSON.parse(http.responseText);
      console.log('Loqat email validation response:', response);

      // Test for an error
      if (response.Items.length == 1 && typeof(response.Items[0].ResponseCode) != "undefined") {
        if (response.Items[0].ResponseCode === 'Timeout') {
          window.dataLayer = window.dataLayer || []

          window.dataLayer.push({
            event: 'loqate_timeout',
            message: response.Items[0].ResponseMessage
          })
        }

        callback(response.Items[0].ResponseCode === 'Invalid');
      } else {
        window.dataLayer = window.dataLayer || []

        window.dataLayer.push({
          event: 'loqate_error',
          message: response.Items[0].ResponseMessage
        })

        return false;
      }
    }
  }
  http.send(params);
}

/**
* Return user to top of page 
*/
export const scrollToTop = () => {
  window.scrollTo({
      top: 0,
      behavior: "smooth",
  });
};